import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LazyLoadedImage from '@dc/ui-library/src/organisms/LazyLoadedImage/LazyLoadedImage';
import Button from '@dc/ui-library/src/molecules/Button/Button';
import ComparePanelProductTooltip from './ComparePanelProductTooltip.jsx';

const MAX_NUMBER = 4;

class ComparePanel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isComparePanelProductTooltipVisible: false,
      productIdOfVisibleTooltip: null
    };

    this.productToRemove = this.productToRemove.bind(this);
    this.showComparePanelProductTooltip = this.showComparePanelProductTooltip.bind(this);
    this.hideComparePanelProductTooltip = this.hideComparePanelProductTooltip.bind(this);
  }

  productToRemove(index) {
    this.props.onRemoveProduct(index);
  }

  showComparePanelProductTooltip(product) {
    if (!this.state.isComparePanelProductTooltipVisible ||
      this.state.productIdOfVisibleTooltip !== product.id) {
      this.setState({
        isComparePanelProductTooltipVisible: true,
        productIdOfVisibleTooltip: product.id
      });
      this.props.onPopupDisplay(product.id);
    }
  }

  hideComparePanelProductTooltip() {
    if (this.state.isComparePanelProductTooltipVisible) {
      this.setState({
        isComparePanelProductTooltipVisible: false,
        productIdOfVisibleTooltip: null
      });
    }
  }

  isEmailMeBackLinkShownForProduct(channelsAvailability) {
    if (channelsAvailability.placeSpecificAvailability &&
      channelsAvailability.placeSpecificAvailability.showEmailMeBack) {
      return true;
    } else if (channelsAvailability.defaultAvailability.showEmailMeBack) {
      return true;
    }

    return false;
  }

  render() {
    const compareItems = [];
    const { props } = this;

    for (let i = 0; i < MAX_NUMBER; i++) {
      compareItems.push(
        <div
          className={props.products[i]
            ? 'dc-compare-panel-item'
            : 'dc-compare-panel-item dc-compare-panel-item-empty'}
          key={i}
        >
          {props.products[i] && (
            <div>
              <div className="dc-compare-panel-item-link">
                <a
                  className="dc-compare-panel-item-link__anchor"
                  href={props.products[i].link}
                  onClick={(e) => {
                    e.preventDefault();
                    this.showComparePanelProductTooltip(props.products[i]);
                  }
                  }
                >
                  <LazyLoadedImage
                    src={props.products[i].image.src}
                    alt={props.products[i].title ? props.products[i].title : ''}
                  />
                </a>
              </div>
              <Button
                type="button"
                style="link"
                onClick={() => this.productToRemove(props.products[i])}
              >
                {this.props.translations.removeLabel}
              </Button>
              {this.state.isComparePanelProductTooltipVisible &&
                this.state.productIdOfVisibleTooltip === props.products[i].id &&
                  <div className="dc-compare-panel-product__tooltip">
                    <ComparePanelProductTooltip
                      imageUrl={props.products[i].image.src}
                      price={props.products[i].price.price}
                      title={props.products[i].title}
                      productUrl={props.products[i].link}
                      translations={props.translations}
                      comboKitItemNames={props.products[i].comboKitItemNames}
                      imageAlt={props.products[i].image.label}
                      isOutOfStock={props.products[i].isOutOfStock}
                      isComboKit={props.products[i].isComboKit}
                      mainProductCurrentPrice={
                        props.products[i].price.mainProductCurrentPrice
                      }
                      mainProductWasPrice={props.products[i].price.mainProductWasPrice}
                      onCloseButtonClick={this.hideComparePanelProductTooltip}
                      onClickOutsideOfTooltip={this.hideComparePanelProductTooltip}
                      showEmailMeBack={
                        this.isEmailMeBackLinkShownForProduct(
                          props.products[i].channelsAvailability
                        )
                      }
                      onEmailMeBackLinkClicked={
                        this.isEmailMeBackLinkShownForProduct(
                        props.products[i].channelsAvailability
                        )
                        ? (e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          props.onEmailMeButtonClickInTooltip(props.products[i].id);
                        }
                        : undefined
                      }
                      onScroll={this.hideComparePanelProductTooltip}
                      brand={props.products[i].brand.title}
                      savingsPrice={props.products[i].price.savingsPrice}
                      separateSellingPrice={props.products[i].price.separateSellingPrice}
                      wasPrice={props.products[i].price.wasPrice}
                      wasPriceFrom={props.products[i].price.wasPriceFrom}
                      wasPriceTo={props.products[i].price.wasPriceTo}
                    />
                  </div>
              }
            </div>

          )}
        </div>
      );
    }

    return (
      <div>
        {props.products.length > 0 &&
          <div className="dc-compare-panel">
            <div className="dc-compare-panel-heading">{this.props.translations.title}</div>

            { compareItems }

            <div className="dc-site-currys dc-compare-panel-button">
              <Button style="full" onClick={props.buttonClick}>
                {this.props.translations.compareLabel}
              </Button>
            </div>
          </div>
        }
      </div>
    );
  }
}

ComparePanel.displayName = 'ComparePanel';

ComparePanel.propTypes = {
  buttonClick: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.object),
  onRemoveProduct: PropTypes.func,
  onPopupDisplay: PropTypes.func,
  onEmailMeButtonClickInTooltip: PropTypes.func,
  translations: PropTypes.objectOf(PropTypes.string).isRequired
};

ComparePanel.defaultProps = {
  buttonClick: () => {},
  products: [],
  onRemoveProduct: () => {},
  onPopupDisplay: () => {},
  onEmailMeButtonClickInTooltip: () => {}
};

export default ComparePanel;
